export default ['bg', 'en']
